import { render, staticRenderFns } from "./companyOrderForAgent.vue?vue&type=template&id=3aedf39e&scoped=true&"
import script from "./companyOrderForAgent.vue?vue&type=script&lang=js&"
export * from "./companyOrderForAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aedf39e",
  null
  
)

export default component.exports